/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface BatteryEventOffsetUSMarker {
  size?: number,
  containerColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for battery events of the asset
 *
 * ```typescript
 *  import {getBatteryEventOffsetUSMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getBatteryEventOffsetUSMarker({size, containerColor, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getBatteryEventOffsetUSMarker = ({
  fillColor = dlsColor('black'),
  containerColor = dlsColor('white'),
  size = 48
}: BatteryEventOffsetUSMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_434_80)'>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M36.2 13.2C30.2353 13.2 25.4 18.0353 25.4 24C25.4 29.9647 30.2353 34.8 36.2 34.8C42.1647 34.8 47 29.9647 47 24C46.9934 18.0381 42.162 13.2066 36.2 13.2Z' fill='#BDBDBD'/>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M36.2 33C41.1705 33 45.2 28.9705 45.2 24C45.2 19.0294 41.1705 15 36.2 15C31.2294 15 27.2 19.0294 27.2 24C27.2056 28.9683 31.2317 32.9944 36.2 33Z' fill='${containerColor}'/>
        <mask id='mask0_434_80' style='mask-type:luminance' maskUnits='userSpaceOnUse' x='32' y='17' width='8' height='13'>
          <path d='M39.71 17.7009H32.6V29.5809H39.71V17.7009Z' fill='${containerColor}'/>
        </mask>
        <g mask='url(#mask0_434_80)'>
          <path d='M36.74 24.8109H35.57V21.3009H36.74V24.8109ZM36.74 27.2409H35.57V26.0709H36.74V27.2409ZM38.99 18.8709H38V17.7009H34.4V18.8709H33.41C32.96 18.8709 32.6 19.2309 32.6 19.6809V28.7709C32.6 29.2209 32.96 29.5809 33.41 29.5809H38.9C39.35 29.5809 39.71 29.2209 39.71 28.7709V19.6809C39.71 19.2309 39.35 18.8709 38.99 18.8709Z' fill='${fillColor}'/>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_434_80'>
          <rect width='21.6' height='21.6' fill='${containerColor}' transform='translate(25.4 13.2)'/>
        </clipPath>
      </defs>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getBatteryEventOffsetUSMarker;
